'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var utils = require('./utils.js');
var TV40$1 = require('./svg_source/Device/TV40.svg.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var TV40 = function TV40(props) {
  return /*#__PURE__*/React__default["default"].createElement(utils["default"], _rollupPluginBabelHelpers["extends"]({}, props, {
    src: TV40$1["default"],
    _className: "TV40"
  }));
};

exports["default"] = TV40;
